{
  "INDIVIDUAL": "Individual",
  "PUBLICLY_LISTED_ENTITY": "Publicly Listed Entity",
  "PRIVATE_COMPANY": "Private Company",
  "PARTNERSHIP": "Partnership",
  "SOLE_PROPRIETORSHIP": "Sole Proprietorship",
  "TRUST": "Trust",
  "INVESTMENT_FUND": "Investment Fund",
  "REGULATED_ENTITY": "Regulated Entity",
  "OTHER": "Other",
  "NON_INDIVIDUAL": "Non-individual"
}
